import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Switch,
  InputItem,
  Picker,
  Toast,
  Drawer,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import allUrl from "../../../api/allUrl";
import { post, get, postRaw } from "../../../api/service/services";
import tool from "../../../api/tool";
class Preview extends React.Component {
  render() {
    let data = tool.get("submitData");
    console.log(data,'预览数据');
    const asscateData = tool.get("asscateData") || [];
    return (
      <div className="preview-cont">
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>被反映人:</span>
          {data && data.personName ? data.personName : ""}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>被反映人单位:</span>
          {data.personOrgDes}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            被反映人单位地址:
          </span>
          {data.cityNameData.join("-")}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            {" "}
            被反映人单位详细地址:
          </span>
          {data.byAddress}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>被反映人职务:</span>
          {data.personPost}
        </div>
        {/* <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}> 问题类别:</span>
          {data.leibieNameData.join("-")}
        </div> */}
        <div className="text-center">
          <span style={{ color: "#000", fontSize: "17px" }}>主要诉求:</span>

          <br />
          {data.mainAppeal}
        </div>
        <div className="text-center">
          <span style={{ color: "#000", fontSize: "17px" }}> 事实和理由:</span>
          <br />
          {data.complaintReason}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>联名人数:</span>
          {asscateData.length}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            是否有复核意见书:
          </span>
          {data.hasPosition ? "是" : "否"}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            法院是否已受理:
          </span>
          {data && data.isAccept ? "是" : "否"}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            是否已行政复议:
          </span>
          {data && data.isReview ? "是" : "否"}
        </div>
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>
            仲裁机构是否已受理:
          </span>
          {data && data.isArbitrate ? "是" : "否"}
        </div>
        {/* <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>是否允许公开:</span>
          {data && data.isPublic ? "是" : "否"}
        </div> */}
      </div>
    );
  }
}
export default Preview;
